export const DEFAULT_SERIES_NAME = 'vmind_default_series';
